import { IconCheck, IconError } from '@tvg/fuse-icons';
import { BorderRadiusCss } from '@tvg/fuse-utils';
import React from 'react';

const config = {
	componentName: 'fuse-dropdown',
	icon: {
		error: {
			state: <IconError />,
			label: '',
		},
		success: {
			state: <IconCheck />,
			label: '',
		},
		size: 'small',
	},
};

const styledDropdownConfig = {
	borderColor: {
		error: 'var(--color-functional-errorMid)',
		success: 'var(--color-functional-successMid)',
		completed: 'var(--color-greys-grey7)',
	},
	borderRadius: BorderRadiusCss('l'),
	borderWidth: '1px',
	componentName: config.componentName,
	helperTextColor: {
		error: 'var(--color-functional-errorMid)',
		success: 'var(--color-functional-successMid)',
	},
};

export { config, styledDropdownConfig };
